<script setup>
  import { storeToRefs } from "pinia";
  import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
  import GeneralSection from "@/components/MCampaign/Audiences/AudienceEdit/GeneralSection.vue";
  import DemographicsSection from "@/components/MCampaign/Audiences/AudienceEdit/DemographicsSection.vue";
  import LocationSection from "@/components/MCampaign/Audiences/AudienceEdit/LocationSection/LocationSection.vue";
  import LocalesSection from "@/components/MCampaign/Audiences/AudienceEdit/LocalesSection.vue";
  import InterestsSection from "@/components/MCampaign/Audiences/AudienceEdit/InterestsSection.vue";
  import { useMAudienceStore } from "@stores/mAudience/mAudience";

  const audienceStore = useMAudienceStore();

  const { getMAudienceName } = storeToRefs(audienceStore);
</script>

<template>
  <Card class="p-6">
    <CardHeader
      v-if="getMAudienceName != null"
      class="pb-4">
      <CardTitle class="heading-page">
        {{ getMAudienceName }}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <GeneralSection />
      <DemographicsSection />
      <LocationSection />
      <LocalesSection />
      <InterestsSection />
    </CardContent>
  </Card>
</template>
